import React, { useState } from "react";
import PropTypes from "prop-types";
import style from "./loadingIcon.module.css";

function LoadingIcon({ hover, color }) {
    // Define dynamic ball classes based on hover
    const ball1Style = hover ? style.ball1Hover : style.ball1;
    const ball2Style = hover ? style.ball2Hover : style.ball2;
    const ball3Style = hover ? style.ball3Hover : style.ball3;

    // If the `color` prop is provided, apply it to each ball
    const ballStyle = {
        backgroundColor: color || "white", // Default to white if no color is provided
    };

    return (
        <div className={style.multiple1}>
            <div className={ball1Style} style={ballStyle} />
            <div className={ball2Style} style={ballStyle} />
            <div className={ball3Style} style={ballStyle} />
        </div>
    );
}

LoadingIcon.propTypes = {
    hover: PropTypes.bool,
    color: PropTypes.string,
};

export default LoadingIcon;
